module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAABGUlEQVQokZXSvytFcRjH8dc9V0oZlAFlkB+lKFFiUbITZTh/BFnufr5HFquwKpbDKItBWO7iX7CSAZMySAz3yHHdm+szfZ/n+byf5/urFEJQryRkHdjEYxri7fp61ABoxxkq6PjVsRGUmxfyddufUBKyEtYKqe5CbSEJWX+jSWPoK8QjOVDBRV6vjU9C1osuDNc1mUtCNoCtPJ7Befny6qENl3nyDcsFqIwpDOVx7/X8+F7pw+giTnGDfRw0OnxBs5Hvm5rGyh8ArEboKSSWWoB6Ijy1YCzqOUL1n1C19GG0E7d+brOZHjAYpSF+wUaLUzbSEL9GkIb4OAffm5jfsZ6G+ITCN0pDvINJHOFe7aHvcIiJNMS7X95P1sNAsDuhOgAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/offcn-live-goods/img/activity_icon.png
// module id = ISW+
// module chunks = 1